import { useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from '../../../Axios'


export default function AddTender() {
  const [tender, setTender] = useState({
    description: "",
    publicationDate: "",
    lastSubmissionDate: "",
    openingDate: "",
    pdfUrl: "",
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTender((prevTender) => ({
      ...prevTender,
      [name]: value,
    }));
  };

  const handleAddTender = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await api.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/tenders`,
        tender
      );
      toast.success("Tender added successfully!");
      setTender({
        description: "",
        publicationDate: "",
        lastSubmissionDate: "",
        openingDate: "",
        pdfUrl: "",
      });
    } catch (err) {
      console.error(err);
      toast.error("Failed to add tender.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto px-6 lg:px-16 py-10 bg-white shadow-lg rounded-lg max-w-2xl">
      <h2 className="text-3xl font-bold mb-6 text-teal-600 text-center">Add New Tender</h2>
      <form onSubmit={handleAddTender} className="space-y-6">
        <div className="mb-6">
          <label htmlFor="description" className="block text-lg font-semibold text-teal-600">
            Description
          </label>
          <input
            type="text"
            id="description"
            name="description"
            value={tender.description}
            onChange={handleInputChange}
            className="w-full p-3 border-2 border-teal-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
        </div>

        <div className="mb-6">
          <label htmlFor="publicationDate" className="block text-lg font-semibold text-teal-600">
            Publication Date
          </label>
          <input
            type="date"
            id="publicationDate"
            name="publicationDate"
            value={tender.publicationDate}
            onChange={handleInputChange}
            className="w-full p-3 border-2 border-teal-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
        </div>

        <div className="mb-6">
          <label htmlFor="lastSubmissionDate" className="block text-lg font-semibold text-teal-600">
            Last Submission Date
          </label>
          <input
            type="date"
            id="lastSubmissionDate"
            name="lastSubmissionDate"
            value={tender.lastSubmissionDate}
            onChange={handleInputChange}
            className="w-full p-3 border-2 border-teal-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
        </div>

        <div className="mb-6">
          <label htmlFor="openingDate" className="block text-lg font-semibold text-teal-600">
            Opening Date
          </label>
          <input
            type="date"
            id="openingDate"
            name="openingDate"
            value={tender.openingDate}
            onChange={handleInputChange}
            className="w-full p-3 border-2 border-teal-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
        </div>

        <div className="mb-6">
          <label htmlFor="pdfUrl" className="block text-lg font-semibold text-teal-600">
            PDF URL
          </label>
          <input
            type="text"
            id="pdfUrl"
            name="pdfUrl"
            value={tender.pdfUrl}
            onChange={handleInputChange}
            className="w-full p-3 border-2 border-teal-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
        </div>

        <div className="flex justify-between">
          <button
            type="button"
            onClick={() =>
              setTender({
                description: "",
                publicationDate: "",
                lastSubmissionDate: "",
                openingDate: "",
                pdfUrl: "",
              })
            }
            className="bg-gray-500 text-white px-6 py-3 rounded-md hover:bg-gray-600 transition-all duration-200"
          >
            Clear
          </button>

          <button
            type="submit"
            disabled={loading}
            className="bg-teal-500 text-white px-6 py-3 rounded-md hover:bg-teal-600 transition-all duration-200"
          >
            {loading ? "Adding..." : "Add Tender"}
          </button>
        </div>
      </form>
      <ToastContainer position="top-right" autoClose={5000} />
    </div>
  );
}
